module.exports = __webpack_public_path__ + "static/media/Left legs22.a0aeea0e.png";